import React from 'react'
import './App.css'
import { Route, Switch } from 'react-router-dom'

import Login from './Login'
import Home from './components/Home'
import editProfile from './components/editProfile'
import 'antd/dist/antd.css'

const App = () => (
  <div className="App">
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/home" component={Home} />
      <Route path="/edit-profile" component={editProfile} />
      <Route component={Home} />
    </Switch>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js